/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FilterOptionsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Blueprint materials filter
 */
export const filtersBlueprintsMaterials = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/blueprints/materials`, method: 'GET', signal
    },
      );
    }




export const getFiltersBlueprintsMaterialsQueryKey = () => {
    return [
    'filters','blueprints','materials'
    ] as const;
    }


export const getFiltersBlueprintsMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFiltersBlueprintsMaterialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>> = ({ signal }) => filtersBlueprintsMaterials(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>
}

export type FiltersBlueprintsMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>>
export type FiltersBlueprintsMaterialsQueryError = ErrorType<unknown>


/**
 * @summary Blueprint materials filter
 */

export function useFiltersBlueprintsMaterials<TData = Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersBlueprintsMaterials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFiltersBlueprintsMaterialsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission orgs filter
 */
export const filtersGameMissionsOrgs = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/missions/orgs`, method: 'GET', signal
    },
      );
    }




export const getFiltersGameMissionsOrgsQueryKey = () => {
    return [
    'filters','missions','orgs'
    ] as const;
    }


export const getFiltersGameMissionsOrgsQueryOptions = <TData = Awaited<ReturnType<typeof filtersGameMissionsOrgs>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsOrgs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFiltersGameMissionsOrgsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filtersGameMissionsOrgs>>> = ({ signal }) => filtersGameMissionsOrgs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsOrgs>>, TError, TData>
}

export type FiltersGameMissionsOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof filtersGameMissionsOrgs>>>
export type FiltersGameMissionsOrgsQueryError = ErrorType<unknown>


/**
 * @summary Mission orgs filter
 */

export function useFiltersGameMissionsOrgs<TData = Awaited<ReturnType<typeof filtersGameMissionsOrgs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFiltersGameMissionsOrgsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission reward kinds filter
 */
export const filtersGameMissionsRewardKinds = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/missions/reward-kinds`, method: 'GET', signal
    },
      );
    }




export const getFiltersGameMissionsRewardKindsQueryKey = () => {
    return [
    'filters','missions','reward-kinds'
    ] as const;
    }


export const getFiltersGameMissionsRewardKindsQueryOptions = <TData = Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFiltersGameMissionsRewardKindsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>> = ({ signal }) => filtersGameMissionsRewardKinds(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>, TError, TData>
}

export type FiltersGameMissionsRewardKindsQueryResult = NonNullable<Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>>
export type FiltersGameMissionsRewardKindsQueryError = ErrorType<unknown>


/**
 * @summary Mission reward kinds filter
 */

export function useFiltersGameMissionsRewardKinds<TData = Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsRewardKinds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFiltersGameMissionsRewardKindsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission standings filter
 */
export const filtersGameMissionsStandings = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/missions/standings`, method: 'GET', signal
    },
      );
    }




export const getFiltersGameMissionsStandingsQueryKey = () => {
    return [
    'filters','missions','standings'
    ] as const;
    }


export const getFiltersGameMissionsStandingsQueryOptions = <TData = Awaited<ReturnType<typeof filtersGameMissionsStandings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsStandings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFiltersGameMissionsStandingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filtersGameMissionsStandings>>> = ({ signal }) => filtersGameMissionsStandings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsStandings>>, TError, TData>
}

export type FiltersGameMissionsStandingsQueryResult = NonNullable<Awaited<ReturnType<typeof filtersGameMissionsStandings>>>
export type FiltersGameMissionsStandingsQueryError = ErrorType<unknown>


/**
 * @summary Mission standings filter
 */

export function useFiltersGameMissionsStandings<TData = Awaited<ReturnType<typeof filtersGameMissionsStandings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filtersGameMissionsStandings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFiltersGameMissionsStandingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






